// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
import RoleSwitcherController from "./role_switcher_controller"
application.register("role-switcher", RoleSwitcherController)
import IncidentFormController from "./incident_form_controller"
application.register("incident-form", IncidentFormController)
import IncidentFormHeaderController from "./incident_form_header_controller"
application.register("incident-form-header", IncidentFormHeaderController)
import MedicationSearchController from "./medication_search_controller"
application.register("medication-search", MedicationSearchController)
import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)
import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)
import EmailTrimController from "./email_trim_controller"
application.register("email-trim", EmailTrimController)
import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
import PharmacySearchController from "./pharmacy_search_controller"
application.register("pharmacy-search", PharmacySearchController)
import PostalCodeController from "./postal_code_controller"
application.register("postal-code", PostalCodeController)
import ReferralCodeController from "./referral_code_controller"
application.register("referral-code", ReferralCodeController)
import ReferralClipboardController from "./referral_clipboard_controller"
application.register("referral-clipboard", ReferralClipboardController)
import TermsCheckboxController from "./terms_checkbox_controller"
application.register("terms-checkbox", TermsCheckboxController)
import CqiMeetingFormController from "./cqi_meeting_form_controller"
application.register("cqi-meeting-form", CqiMeetingFormController)
import "./railsui"

// Auto-attach controllers to matching inputs
function autoAttachControllers() {
  document.querySelectorAll('input[type="email"]').forEach((input) => {
    if (!input.dataset.controller?.includes("email-trim")) {
      input.dataset.controller = input.dataset.controller
        ? `${input.dataset.controller} email-trim`
        : "email-trim"
    }
  })

  document.querySelectorAll('input[name*="postal_code"]').forEach((input) => {
    if (!input.dataset.controller?.includes("postal-code")) {
      input.dataset.controller = input.dataset.controller
        ? `${input.dataset.controller} postal-code`
        : "postal-code"
    }
  })
}

document.addEventListener("turbo:load", autoAttachControllers)
document.addEventListener("DOMContentLoaded", autoAttachControllers)
